import { createActions, createReducer } from "reduxsauce";

//Action types e Creators
export const { Types, Creators } = createActions({
  printerGetDefaultSuccess: ['printer'],
  printerGetDefaultFail: ['error'],
  printerWriteClean: [],
  printerWriteSuccess: ['result'],
  printerWriteError: ['error'],
  printerWriteLoading: [],
  printerReadSuccess: [],
  printerReadError: [],
});

//Reducer Handlers
const INITIAL_STATE = { 
  printer: undefined,
  error: undefined,
  loading: false,
  success: false,
};

const cleanWrite = (state = INITIAL_STATE, action) => {
    return { ...INITIAL_STATE };
};

const printerGetDefaultSuccess = (state = INITIAL_STATE, action) => {
  return {...state, printer: action.printer};
}

const printerGetDefaultFail = (state = INITIAL_STATE, action) =>
  INITIAL_STATE

const printerWriteSuccess = (state = INITIAL_STATE, action) =>
  ({...state, loading: false, error: undefined, success: true})

const printerWriteError = (state = INITIAL_STATE, action) =>
  ({...state, error: action.error, loading: false, success: false})

const printerWriteLoading = (state = INITIAL_STATE, action) =>
  ({...state, error: undefined, loading: true, success: true})

const printerReadSuccess = (state = INITIAL_STATE) =>
  (false)

const printerReadError = (state = INITIAL_STATE) =>
  (false)  


//Criando Reducer
export default createReducer(INITIAL_STATE, {
  [Types.PRINTER_GET_DEFAULT_SUCCESS]: printerGetDefaultSuccess,
  [Types.PRINTER_GET_DEFAULT_FAIL]: printerGetDefaultFail,
  [Types.PRINTER_WRITE_CLEAN]: cleanWrite,
  [Types.PRINTER_WRITE_SUCCESS]: printerWriteSuccess,
  [Types.PRINTER_WRITE_ERROR]: printerWriteError,
  [Types.PRINTER_WRITE_LOADING]: printerWriteLoading,
  [Types.PRINTER_READ_SUCCESS]: printerReadSuccess,
  [Types.PRINTER_READ_ERROR]: printerReadError,
});
